export enum ELowerMenuItems {
  catalog = "catalog",
  newBooks = "newBooks",
  popular = "popular",
  audiobooks = "audiobooks",
  selfpub = "selfpub",
  subscription = "subscription",
  promoCodes = "promoCodes",
  more = "more",
  company = "company",
  compilations = "compilations",
  drafts = "drafts",
  podcasts = "podcasts",
  comics = "comics",
  fanfics = "fanfics",
  lectures = "lectures",
  journal = "journal",
  certificatePresent = "certificatePresent",
  litresSubscription = "litresSubscription",
  litresAbonement = "litresAbonement",
  corporateLibrary = "corporateLibrary",
  litresReader = "litresReader",
  publishYourBook = "publishYourBook",
  mobileApps = "mobileApps",
  becomeAnAuthor = "becomeAnAuthor",
  detskieKnigi = "detskieKnigi",
  litresLandingTrOnly = "litresLandingTrOnly",
}
export const LOWER_MENU_ITEMS = [
  {
    id: ELowerMenuItems.subscription,
    title: "Подписка за 0 ₽",
    href: "/litres_subscription/",
    isOrange: true,
    isMainDomainOnly: true,
  },
  {
    id: ELowerMenuItems.promoCodes,
    title: "Промокод",
    href: "/promocode/",
    isOrange: true,
  },
  {
    id: ELowerMenuItems.newBooks,
    title: "Новинки",
    href: "/new/",
  },
  {
    id: ELowerMenuItems.popular,
    title: "Популярное",
    href: "/popular/",
  },
  {
    id: ELowerMenuItems.compilations,
    title: "Подборки",
    href: "/collections/",
  },
  {
    id: ELowerMenuItems.audiobooks,
    title: "Аудиокниги",
    href: "/audiobooks/",
  },
  {
    id: ELowerMenuItems.selfpub,
    title: "Эксклюзивы",
    href: "/selfpublishing/",
    isMainDomainOnly: true,
  },
  {
    id: ELowerMenuItems.drafts,
    title: "Черновики",
    href: "/drafts/",
    isMainDomainOnly: true,
  },
  {
    id: ELowerMenuItems.podcasts,
    title: "Подкасты",
    href: "/podcasts/",
    isMainDomainOnly: true,
  },
  {
    id: ELowerMenuItems.comics,
    /* Для ru доменов: Комиксы и вебтуны */
    title: "Комиксы",
    href: "/genre/komiksy-i-manga-274060/?view=showroom",
  },
  {
    id: ELowerMenuItems.journal,
    title: "Журнал",
    href: "/journal/",
    isMainDomainOnly: true,
  },
  {
    id: ELowerMenuItems.certificatePresent,
    title: "Сертификаты",
    href: "/certificate-present/",
    isMainDomainOnly: true,
  },
  {
    id: ELowerMenuItems.becomeAnAuthor,
    title: "Стать автором",
    href: "https://selfpub.ru/?utm_source=litres&utm_medium=header&utm_campaign=top",
  },
  {
    id: ELowerMenuItems.company,
    title: "О компании",
    href: "",
  },
  // только для Турции
  {
    id: ELowerMenuItems.litresLandingTrOnly,
    title: "Kitabınızı Yayımlayın",
    href: "https://landing.selfpub.ru/turkey/",
  },
];

export const LOWER_MENU_ITEMS_MORE = [
  {
    id: ELowerMenuItems.detskieKnigi,
    title: "Детская литература",
    href: "/genre/detskie-knigi-5007/?view=showroom",
    isMainDomainOnly: true,
  },
  {
    id: ELowerMenuItems.fanfics,
    title: "Фанфики",
    href: "/showroom/fanfic/",
    isMainDomainOnly: true,
  },
  {
    id: ELowerMenuItems.litresSubscription,
    title: "Литрес Подписка",
    href: "/litres_subscription/",
    isMainDomainOnly: true,
  },
  {
    id: ELowerMenuItems.litresAbonement,
    title: "Литрес Абонемент",
    href: "/abonement/",
    isMainDomainOnly: true,
  },
  {
    id: ELowerMenuItems.lectures,
    title: "Лекции",
    href: "/showroom/lectures/",
    isMainDomainOnly: true,
  },
  {
    id: ELowerMenuItems.corporateLibrary,
    title: "Корпоративная библиотека",
    href: "/cms/corp-library/",
    isMainDomainOnly: true,
  },
  {
    id: ELowerMenuItems.litresReader,
    title: "Литрес Чтец",
    href: "/cms/7330/",
    isMainDomainOnly: true,
  },
  {
    id: ELowerMenuItems.publishYourBook,
    title: "Издать свою книгу",
    href: "/selfpub/",
    isMainDomainOnly: true,
  },
  {
    id: ELowerMenuItems.mobileApps,
    title: "Мобильные приложения",
    href: "/app/",
  },
];
